import { render, staticRenderFns } from "./dsn-footer.vue?vue&type=template&id=d19d1bc0&"
var script = {}
import style0 from "./dsn-footer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports